import type { PropsWithChildren } from "react";
import { useMemo, useState } from "react";

import type { IMediaPreviewActions, IMediaPreviewState, MediaStatus } from "./MediaPreviewContext";
import { MediaPreviewContext } from "./MediaPreviewContext";

export const MediaPreviewProvider = ({ children }: PropsWithChildren) => {
    const [status, setStatus] = useState<MediaStatus>("loading");
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState<number | null>(null);

    const actions: IMediaPreviewActions = useMemo(
        () => ({
            setLoaded: () => setStatus("loaded"),
            setError: () => setStatus("error"),
            setPlaying: (playing: boolean) => setIsPlaying(playing),
            setDuration: (d: number | null) => setDuration(d),
        }),
        [],
    );

    const state: IMediaPreviewState = useMemo(() => ({ status, isPlaying, duration }), [status, isPlaying, duration]);

    const value = useMemo(() => ({ state, actions }), [state, actions]);

    return <MediaPreviewContext value={value}>{children}</MediaPreviewContext>;
};
